var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54669 11.1322L0.300991 4.9732C-0.10033 4.57745 -0.10033 3.93585 0.300991 3.54011C0.702255 3.14436 1.35295 3.14436 1.75427 3.54011L8.00004 9.69872L14.2458 3.54005C14.6184 3.17257 15.2061 3.14632 15.6094 3.46131L15.699 3.54005C16.1003 3.93574 16.1003 4.5774 15.699 4.97314L9.45219 11.1311L9.45325 11.1322L7.99997 12.5653L6.54669 11.1322Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDown);
export default __webpack_public_path__ + "static/media/move-down.cd39b56f73036fc1b6ebbd5c54587ecd.svg";
export { ForwardRef as ReactComponent };